const collections = [{
  id: 1,
  title: '想去的地方',
}, {
  id: 2,
  title: '中文歌',
}, {
  id: 3,
  title: '绘画技巧',
}, {
  id: 4,
  title: '算法',
}, {
  id: 5,
  title: '开发',
}];

export default collections;